import { useMutation } from "@tanstack/react-query";
import { DataOrParams, GET } from "../services/requests";
import { ENDPOINTS } from "../constants/endpoints";

export const useMutateSubscriptionDetails = () => {
  const mutation = useMutation({
    mutationFn: async (payload: DataOrParams) => {
      const data = await GET(`${ENDPOINTS.subscriptionDetails}`, payload);
      return data;
    }
});

  return { ...mutation };
};
